import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { GlobalProvider } from './store';

// --- COMPONENTS ---
import Splash from './components/Splash';
import Navbar from './components/common/Navbar';

// --- IMPORT PAGES ---
import Home from './Home';
import Portfolio from './pages/portfolio'; // FIXED: Sesuai struktur folder baru kamu
import Courses from './pages/courses';
import Profile from './pages/Profile';
import Settings from './Settings';
import Blog from './pages/blog';
import BlogDetail from './pages/blog/BlogDetail';
import About from './pages/about';

// IMPORT DARI COMPONENTS (Karena di pages tidak ada)
import Community from './components/community';

// Komponen helper agar saat pindah page, scroll balik ke atas
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const [isEntered, setIsEntered] = useState(false);

  // Splash Screen Logic
  if (!isEntered) {
    return <Splash onFinished={() => setIsEntered(true)} />;
  }

  return (
    <GlobalProvider>
      <Router>
        <ScrollToTop />
        <Navbar />

        {/* Container Utama */}
        <main style={styles.mainWrapper}>
          <Routes>
            {/* Route Utama */}
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/community" element={<Community />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/blog/:id" element={<BlogDetail />} />

            {/* Route User & Info */}
            <Route path="/profile" element={<Profile />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/about" element={<About />} />

            {/* Jika user mengetik alamat asal-asalan, lempar ke Home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </Router>
    </GlobalProvider>
  );
}

const styles = {
  mainWrapper: {
    minHeight: '100vh',
    background: '#000', // Sesuai tema gelap Xyrons
    color: '#fff',
    overflowX: 'hidden'
  }
};

export default App;